import ReqClient from './request.class'

/**
 * @description:  AB素材混剪任务提交接口
 * @param {*} data
 * @return {*}
 */
export async function creativeEditorTaskAdd(data) {
  const Req = new ReqClient({
    url: '/api/mixed/shear/add',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description:  AB素材混剪任务列表接口
 * @param {*} data
 * @return {*}
 */
export async function creativeEditorTaskList(params) {
  const Req = new ReqClient({
    url: '/api/mixed/shear/page',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description:  素材混剪任务提交接口
 * @param {*} data
 * @return {*}
 */
export async function creativePlanAdd(data) {
  const Req = new ReqClient({
    url: '/api/mixed/shear/v2/add',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
/**
 * @description:  素材混剪任务更新接口
 * @param {*} data
 * @return {*}
 */
export async function creativePlanSave(data) {
  const Req = new ReqClient({
    url: '/api/mixed/shear/v2/save',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description:  素材混剪任务c重试接口
 * @param {*} data
 * @return {*}
 */
export async function creativePlanRetry(data) {
  const Req = new ReqClient({
    url: '/api/mixed/shear/v2/plan/retry',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 素材混剪任务异步查询接口
 * @param {*} data
 * @return {*}
 */
export async function creativePlanQuery(params) {
  const Req = new ReqClient({
    url: '/api/mixed/shear/v2/page',
    method: 'GET',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 素材混剪任务删除
 * @param {*} data
 * @return {*}
 */
export async function creativePlanDelete(params) {
  const Req = new ReqClient({
    url: '/api/mixed/shear/v2/del',
    method: 'GET',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 素材混剪任务发起
 * @param {*} data
 * @return {*}
 */
export async function creativePlanTaskExec(data) {
  const Req = new ReqClient({
    url: '/api/mixed/shear/v2/exec',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 素材混剪视频发布到素材库
 * @param {*} data
 * @return {*}
 */
export async function releaseLib(data) {
  const Req = new ReqClient({
    url: '/api/mixed/shear/v2/updateImageDetail',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 素材混剪任务下载为zip
 * @param {*} data
 * @return {*}
 */
export async function downloadMaterialAsZip(data) {
  const Req = new ReqClient({
    url: '/api/mixed/shear/v2/downzip',
    method: 'POST',
    data,
    responseType: 'blob'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
